import { useStyletron } from "baseui";
import { StyledSvg } from "baseui/icon";
import React from "react";

export const BackArrowIcon = (props: React.ComponentProps<typeof StyledSvg>) => {
  const [_, $theme] = useStyletron();
  return (
    <StyledSvg viewBox="0 0 16 16" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.7916 13.2084C6.94142 13.3582 7.13751 13.433 7.33364 13.433C7.52977 13.433 7.72586 13.3582 7.87568 13.2084C8.17507 12.909 8.17507 12.4237 7.87568 12.1243L4.51773 8.76632H13.3336C13.7569 8.76632 14.1003 8.42288 14.1003 7.99966C14.1003 7.57643 13.7569 7.23299 13.3336 7.23299H4.51773L7.87568 3.87503C8.17507 3.57565 8.17507 3.09033 7.87568 2.79095C7.5763 2.49156 7.09098 2.49156 6.7916 2.79095L2.12493 7.45761C1.82554 7.757 1.82554 8.24231 2.12493 8.5417L6.7916 13.2084Z"
        fill={props.color ?? (props.$disabled ? $theme.colors.contentStateDisabled : "currentcolor")}
      />
    </StyledSvg>
  );
};
